/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import HistoryIcon from "@mui/icons-material/History";
import {
  COMPANYT_EXCLUDED_FROM_UI,
  COMPANY_ACCOUNT_STATUS,
  COMPANY_ACCOUNT_TYPE,
} from "../../app/Constants/Constants";
import {
  COLLECTOR_BLOCKED_YES,
  STATUS_DISABLED,
} from "../../constants/Constants";

export const titles = [
  {
    key: "status",
    label: "Status",
    sortable: true,
    sortKey: "isBlocked",
  },
  {
    key: "name",
    label: "Name",
    sortable: true,
    sortKey: "company_name",
  },
  {
    key: "activeCollectors",
    label: "Collectors",
  },
  {
    key: "activeConnectors",
    label: "Connectors",
  },
  {
    key: "activeDatapipes",
    label: "Datapipes",
  },
  {
    key: "activeUsers",
    label: "Users",
  },
];

export const getListViewObj = (company) => ({
  key: company.companyId,
  status: {
    value:
      company.isBlocked === COLLECTOR_BLOCKED_YES ||
      company.accountStatus === STATUS_DISABLED,
    view: "status",
  },
  name: {
    value: company.companyName,
  },
  activeCollectors: {
    value: company.activeCollectors || 0,
  },
  activeConnectors: {
    value: company.activeConnectors || 0,
  },
  activeDatapipes: {
    value: company.activeDatapipes || 0,
  },
  activeUsers: {
    value: company.activeUsers || 0,
  },
  _info: {
    key: company.companyUUID,
    company_name: company.companyName,
    city: company.city,
    company_id: company.companyId,
    companyuuid: company.companyUUID,
    created_by: company.createdBy,
    is_blocked: company.isBlocked,
    account_status: company.accountStatus,
    postcode: company.postcode,
    state: company.state,
    account_type: company.accountType,
    billingStartDate: company.billingStartDate,
  },
});
export const getcompanyListViewObj = (companies) => {
  /* istanbul ignore next */
  const companyList = companies.map(
    /* istanbul ignore next */ (company) => {
      const companyVO = {
        company_id: company.companyId,
        company_name: company.companyName,
        companyuuid: company.companyUUID,
        companyType: company.accountType,
        features: company.features,
        exclude: company.hideInUi,
      };
      return companyVO;
    },
  );

  return companyList;
};
export const getAllcompanyListViewObj = (companies) => {
  /* istanbul ignore next */
  const companyList = companies.map(
    /* istanbul ignore next */ (company) => {
      const companyVO = {
        company_id: company.companyId,
        name: company.companyName,
        id: company.companyUUID,
        type: company.accountType,
        features: company.features,
        status: company.accountStatus,
        exclude: company.hideInUi,
      };
      return companyVO;
    },
  );

  return companyList;
};
export const filterBoxData = () => {
  return {
    DPList: [
      {
        name: "Account Type",
        DPValue: COMPANY_ACCOUNT_TYPE.map(
          /* istanbul ignore next */ (accountType) => {
            return {
              id: Math.random().toString(36).slice(2, 7),
              name: accountType.name,
              value: accountType.value,
              type: "accountType",
            };
          },
        ),
      },
      {
        name: "Excluded from UI",
        DPValue: COMPANYT_EXCLUDED_FROM_UI.map(
          /* istanbul ignore next */ (excludedFromUi) => {
            return {
              id: Math.random().toString(36).slice(2, 7),
              name: excludedFromUi,
              type: "excludedFromUi",
            };
          },
        ),
      },
      {
        name: "Status",
        DPValue: COMPANY_ACCOUNT_STATUS.map(
          /* istanbul ignore next */ (status) => {
            return {
              id: Math.random().toString(36).slice(2, 7),
              value: status.value,
              name: status.name,
              type: "status",
            };
          },
        ),
      },
    ],
  };
};
export const filterApiData = (filterData) => {
  const status = [];
  const accountType = [];
  const excludedFromUi = [];
  filterData.map(
    /* istanbul ignore next */ (data) => {
      switch (data.type) {
        case "status":
          status.push(data.value);
          break;
        case "accountType":
          accountType.push(data.value);
          break;
        case "excludedFromUi":
          excludedFromUi.push(data.name !== "Visible");
          break;
        default:
          break;
      }
    },
  );
  return {
    status,
    accountType,
    excludedFromUi,
  };
};
export const filterDefaultData = () => {
  return {
    id: Math.random().toString(36).slice(2, 7),
    name: "Active",
    value: "ACTIVE",
    type: "status",
  };
};
export const defaultCompanyValues = (value) => {
  return {
    companyType: value?.accountType,
    company_name: value?.companyName,
    companyuuid: value?.companyUUID,
    exclude: value?.hideInUi,
  };
};
export const companyToggleIcon = [
  { icon: <LibraryBooksIcon />, value: 0, name: "Company Details" },
  {
    icon: <HistoryIcon />,
    value: 1,
    name: "Change Log",
  },
];
export const companyLogsTable = [
  {
    key: "fieldName",
    label: "Field",
  },
  {
    key: "previousValue",
    label: "Previous Value",
  },
  {
    key: "newValue",
    label: "New Value",
  },
];
